"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.SecondaryActionButton = exports.PrimaryActionButton = exports.Description = exports.SubTitle = exports.BlankSlate = void 0;
var react_1 = __importDefault(require("react"));
var Button_1 = require("../Button");
require("./BlankSlate.css");
var classnames_1 = __importDefault(require("classnames"));
var BlankSlate = function (_a) {
    var children = _a.children, _b = _a.alignment, alignment = _b === void 0 ? '' : _b, _c = _a.title, title = _c === void 0 ? 'You do not have any content.' : _c, _d = _a.headerGraphic, headerGraphic = _d === void 0 ? '' : _d, _e = _a.className, className = _e === void 0 ? '' : _e, restProps = __rest(_a, ["children", "alignment", "title", "headerGraphic", "className"]);
    return (react_1["default"].createElement("div", __assign({}, restProps, { className: "vs-bs-container ".concat(alignment === 'left-side' && 'vs-bs-leftalign', " ").concat(className) }),
        react_1["default"].createElement("div", { className: "vs-bs-img" }, headerGraphic),
        react_1["default"].createElement("div", { className: "vs-bs-content" },
            react_1["default"].createElement("h1", { className: "vs-bs-title" }, title),
            children)));
};
exports.BlankSlate = BlankSlate;
var SubTitle = function (_a) {
    var className = _a.className, children = _a.children;
    return (react_1["default"].createElement("div", { className: (0, classnames_1["default"])('vs-bs-subtitle', className) }, children));
};
exports.SubTitle = SubTitle;
var Description = function (_a) {
    var className = _a.className, children = _a.children;
    return (react_1["default"].createElement("p", { className: (0, classnames_1["default"])('vs-bs-description-text', className) }, children));
};
exports.Description = Description;
var PrimaryActionButton = function (_a) {
    var label = _a.label, _b = _a.handler, handler = _b === void 0 ? function () { } : _b, _c = _a.className, className = _c === void 0 ? '' : _c, restProps = __rest(_a, ["label", "handler", "className"]);
    return (react_1["default"].createElement("div", null,
        react_1["default"].createElement(Button_1.Button, __assign({}, restProps, { type: "solid-primary", className: "vs-bs-button-primary ".concat(className), onClick: handler }), label)));
};
exports.PrimaryActionButton = PrimaryActionButton;
var SecondaryActionButton = function (_a) {
    var label = _a.label, _b = _a.handler, handler = _b === void 0 ? function () { } : _b, _c = _a.className, className = _c === void 0 ? '' : _c, restProps = __rest(_a, ["label", "handler", "className"]);
    return (react_1["default"].createElement("div", null,
        react_1["default"].createElement(Button_1.Button, __assign({}, restProps, { type: "text", className: "vs-bs-button-secondary ".concat(className), onClick: handler }), label)));
};
exports.SecondaryActionButton = SecondaryActionButton;
